module.exports = __webpack_public_path__ + "img/4-disabled.b6bcf937.png";